import { AnnouncementGroupMember } from 'types/user';
import type {
    Announcement as V1Announcement,
    AnnouncementGroup as V1AnnouncementGroup,
    AnnouncementGroupMemberRow,
    CreateAnnouncementPayload,
} from 'types/announcementsV1';

export const ANNOUNCEMENTS = 'announcements';
export const ANNOUNCEMENT_GROUPS = 'announcementGroups';

export type AnnouncementsTabs = typeof ANNOUNCEMENTS | typeof ANNOUNCEMENT_GROUPS;

export interface Announcements {
    currentTab: AnnouncementsTabs;
}

/** Phase 7 — /v1 announcement row (aliases for existing screens). */
export type Announcement = V1Announcement;

/** Phase 7 create/send form — no legacy `data.*` / companyId. */
export type NewAnnouncement = CreateAnnouncementPayload & {
    /** Form-only selected group id (mapped to `groupIds` on submit). */
    groupId?: string | null;
};

export type AnnouncementGroup = V1AnnouncementGroup;

export interface AnnouncementGroupDetailState {
    members: AnnouncementGroupMemberRow[];
    details: AnnouncementGroup | null;
    membersLoading: boolean;
    detailsLoading: boolean;
    error: string | null;
    groupName: string | null;
    groupImage: string | null;
    /** Independent race keys for parallel detail vs members fetches (H3). */
    inflightDetailsParishId: string | null;
    inflightDetailsGroupId: string | null;
    inflightMembersParishId: string | null;
    inflightMembersGroupId: string | null;
    /** Last successful members `total` for the inflight members group. */
    membersTotal: number;
}

export interface RemoveGroupMember {
    userId: string;
    groupId: string;
    parishId: string;
}

export interface AnnouncementState {
    data: Announcement[];
    loading: boolean;
    error: boolean;
    totalCount: number;
    inflightParishId: string | null;
}

export interface SendAnnouncementState {
    loading: boolean;
    error: boolean | string;
}

export interface SendAnnouncementProps {
    defaultValues: NewAnnouncement;
    /** When true, block confirm/send (original audience unknown). */
    resendBlocked?: boolean;
}

export interface AnnouncementDetailState {
    details: Announcement | null;
    loading: boolean;
    error: boolean;
    inflightParishId: string | null;
    inflightAnnouncementId: string | null;
}

export interface DeleteAnnouncementPayload {
    id: string;
    parishId: string;
}

/** @deprecated Prefer AnnouncementGroupMemberRow from announcementsV1. */
export type { AnnouncementGroupMember };
